import React from 'react';

import { Box, Typography } from '@mui/joy';
import { observer } from 'mobx-react-lite';

import { TelemetryGenerator, toHudProps, pilotTelemetryStore } from '../../simulator';
import FlightHUDWidget from '../components/FlightHUDWidget';
import LayoutManager from '../layout/LayoutManager';

const FlightOps: React.FC = observer(() => {
  const store = pilotTelemetryStore;
  const [generator] = React.useState(() => new TelemetryGenerator(store));

  React.useEffect(() => {
    generator.start();
    return () => generator.stop();
  }, [generator]);

  const hudProps = toHudProps(store.telemetry);
  return (
    <Box className='flex flex-col min-h-screen' sx={{ bgcolor: 'background.body', color: 'common.white' }}>
      {/* Top Bar */}
      <Box className='flex justify-between items-center p-2' sx={{ bgcolor: 'neutral.800' }}>
        <Box className='absolute bottom-20 inset-x-0 flex justify-center z-10'>
          <FlightHUDWidget {...hudProps} />
        </Box>
        <Box className='flex-1' />
        <Box className='flex-1 text-center hidden md:block'>
          <Typography level='body-sm' className='uppercase'>
            GPS: 12 | RTK: OK | Alt: 20m | Temp: 72°F
          </Typography>
        </Box>
        <Box className='flex-1 text-right'>
          <Typography level='body-sm'>Controller ✓ | Link ✓ | Battery 85%</Typography>
        </Box>
      </Box>

      {/* Main Content */}
      <Box className='flex-1 relative overflow-hidden'>
        <LayoutManager />
      </Box>

      {/* Bottom Status Strip */}
      <Box className='flex justify-between items-center p-2' sx={{ bgcolor: 'neutral.800' }}>
        <Typography level='body-sm'>Mission ABC123</Typography>
        <Typography level='body-sm'>Sharing: Off</Typography>
        <Typography level='body-sm'>System Normal</Typography>
      </Box>
    </Box>
  );
});

export default FlightOps;
